import axios from 'axios';
import useAxios from 'axios-hooks';
import moment from "moment";
import React, { useState } from 'react';
import { Button, Card, Form, Modal, ProgressBar } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { queryCache, useMutation } from 'react-query';
import Alert from 'react-s-alert';

const VideoUpload = ({ intl, presentations, token }) => {
  return <div>
    {
      presentations.length === 0 && <i>No videos available yet</i>
    }
    {
      presentations.map(presentation => (<div className="m-t-30">
        <VideoUploadSingle key={presentation._id} intl={intl} presentation={presentation} token={token} />
      </div>))
    }
  </div>
}

const VideoUploadSingle = ({ presentation, intl, token }) => {
  const [videoModal, setVideoModal] = useState(false);
  const [progress, setProgress] = useState(0);

  const [updatePresentationMutation, { isLoading: updatePresentationLoading }] = useMutation(({ _id, update }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker-data/update-presentation/${_id}`,
    method: 'PATCH',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    data: update
  }).then(response => response.data), {
    onSuccess: (updatedPresentation) => {
      queryCache.setQueryData(
        ['speaker-presentations', updatedPresentation.event_id, updatedPresentation.speaker_id], 
        (presentations) => presentations
          .map(presentation => presentation._id === updatedPresentation._id ? { ...presentation, ...updatedPresentation } : presentation)
      )
      Alert.closeAll();
      Alert.success(intl.formatMessage({ id: "presentation.update-success" }));
    },
    onError: (err) => {
      Alert.closeAll();
      Alert.error(intl.formatMessage({ id: "error.server-error" }))
    }
  })


  // require presentation_id
  const [{ loading: getVideoTokenLoading }, getVideoToken] = useAxios({
    url: `${process.env.REACT_APP_API_HOST}/speaker-data/video-token/${presentation._id}`,
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`
    }
  }, {
    manual: true
  });

  const [{ loading: uploadVideoLoading }, uploadVideo] = useAxios({
    url: 'https://api.sproutvideo.com/v1/videos',
    method: "POST",
    onUploadProgress: (progress) => {
      setProgress(parseInt(100 * progress.loaded / progress.total))
    }
  }, {
    manual: true
  });

  return <div className="m-t-30">
    <Card className="shadow-card">
      <Card.Header>Video and settings for <b>{presentation.name}</b>,
        {` ${moment(presentation.date).format(
          "DD/MM/YYYY"
        )} ${presentation.time}`}</Card.Header>
      <Card.Body>
        <Form.Group>
          <Form.Check
            type="checkbox"
            id={`${presentation._id}_public`}
            checked={presentation.public}
            disabled={updatePresentationLoading}
            onChange={(e) => updatePresentationMutation({
              _id: presentation._id,
              update: {
                public: e.target.checked
              }
            })}
            label={intl.formatMessage({
              id: "label.agree-broadcast",
            })}
          />
        </Form.Group>
        <Form.Group>
          <Form.Check
            type="checkbox"
            id={`${presentation._id}_pdfConvert`}
            checked={presentation.pdfConvert}
            disabled={updatePresentationLoading}
            onChange={(e) => updatePresentationMutation({
              _id: presentation._id,
              update: {
                pdfConvert: e.target.checked
              }
            })}
            label={intl.formatMessage({
              id: "label.agree-pdfConvert",
            })}
          />
        </Form.Group>
        <Button onClick={() => setVideoModal(true)}>Upload Video</Button>
        <Modal show={videoModal} onHide={() => {}}>
          <Modal.Header>
            <Modal.Title>Upload video for <b>{presentation.name}</b></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input type="file" accept="video/mp4,video/x-m4v,video/*" onChange={async (e) => {
              const file = e.target.files[0];
              try {
                const tokenResponse = await getVideoToken();
                const uploadToken = tokenResponse.data;

                var formData = new FormData();
                formData.append("source_video", file);
                formData.append("token", uploadToken);
                const videoUpload = await uploadVideo({
                  data: formData
                });

                await updatePresentationMutation({
                  _id: presentation._id,
                  update: {
                    video: {
                      id: videoUpload.data.id,
                      security_token: videoUpload.data.security_token,
                    }
                  }
                })
              } catch (e) {
                Alert.error(intl.formatMessage({ id: "error.server-error" }))
              }
              setProgress(0);
              Alert.success(intl.formatMessage({ id: "presentation.update-success" }));
            }} />
            {
              progress
                ? <ProgressBar now={progress} variant="primary" />
                : <div />
            }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setVideoModal(false)} disabled={getVideoTokenLoading || uploadVideoLoading || updatePresentationLoading}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
  </div>
}

export default injectIntl(VideoUpload);
